






































































































































import '../styles/proposals.css'
import { Vue } from 'vue-property-decorator'
import { CIcon } from '@coreui/icons-vue'
import { cilPlus } from '@coreui/icons-pro'

import draggable from 'vuedraggable'
import ScreenTile from '../components/ScreenTile.vue'
import ProposalTile from '../components/proposal/ProposalTile.vue'
import ProposalHistory from '../components/proposal/ProposalHistory.vue'

import RemoveItemModal from '../components/general/RemoveItemModal.vue'
import UpsertProposalModal from '../components/proposal/UpsertProposalModal.vue'
import PendingChangeModal from '../components/general/PendingChangeModal.vue'

interface IProposal {
  id: number
  title: string
  imageUrl: string | undefined
  updatedDate: string
  createdDate: string
  numberOfChildren: number
}

interface IProposalDocument {
  id: number
  documentId: number
  name: string
  imageUrl: string | undefined
  resourceLink: string | undefined
  createdDate: string
  source: string
}

export default Vue.extend({
  components: {
    ScreenTile,
    ProposalTile,
    UpsertProposalModal,
    RemoveItemModal,
    PendingChangeModal,
    CIcon,
    draggable,
    ProposalHistory,
  },
  data: function () {
    return {
      loading: true,
      loadingDetails: false,
      proposals: [] as IProposal[],

      originalOrder: [] as IProposalDocument[],
      proposalDocuments: [] as IProposalDocument[],

      viewItem: {} as IProposal,
      removeItem: {} as IProposal,

      showModal: false,
      showRemoveModal: false,
      showPendingChangeModal: false,
      hasReorderedDocuments: false,

      addIcon: cilPlus,

      currentTab: 0,
      producing: false,
    }
  },
  mounted: async function () {
    this.proposals = await (await fetch(`/api/proposals`)).json()
    this.loading = false
  },
  computed: {
    areDocumentInOriginalOrder(): boolean {
      if (!this.hasReorderedDocuments) return true

      let isSameOrder = true

      for (let index = 0; index < this.originalOrder.length; index++) {
        if (isSameOrder) {
          const oOPD = this.originalOrder[index]
          const cOPD = this.proposalDocuments[index]

          if (oOPD.id !== cOPD.id || oOPD.source !== cOPD.source)
            isSameOrder = false
        }
      }

      return isSameOrder
    },
  },
  methods: {
    updateOrder: async function () {
      // console.log('Updating order of proposal documents')

      try {
        const result = await fetch(`/api/proposals/${this.viewItem.id}`, {
          method: 'PUT',
          body: JSON.stringify({
            title: this.viewItem.title,
            documents: this.proposalDocuments.map((proposalDocument) => ({
              id: proposalDocument.documentId,
              name: proposalDocument.name,
              source: proposalDocument.source,
            })),
          }),
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        })

        // TODO: show an error toast
        if (!result.ok) {
          //  console.log('Failed to update the order of the proposal documents')
        }
      } catch {
        // console.log('Failed to update the order of the proposal documents')
      }

      this.hasReorderedDocuments = false
    },
    upsertProposal: function (item: IProposal) {
      if (item) {
        if (this.viewItem?.id)
          this.proposals = this.proposals.filter(
            (proposal) => proposal.id !== item.id
          )
        this.proposals.push(item)
      }

      this.showModal = false
      this.changeView(null)
    },
    confirmChange: async function () {
      if (this.areDocumentInOriginalOrder) this.changeView(null)
      else this.showPendingChangeModal = true
    },
    changeView: async function (id: number | null) {
      if (id === null) {
        this.showPendingChangeModal = false
        this.hasReorderedDocuments = false
        this.viewItem = {} as IProposal
        this.proposalDocuments = []
        this.originalOrder = []
      } else {
        this.loadingDetails = true

        this.viewItem =
          this.proposals.find((proposal) => proposal.id === id) ??
          ({} as IProposal)
        this.proposalDocuments = await (
          await fetch(`/api/proposals/${id}/documents`)
        ).json()

        this.loadingDetails = false
      }
    },
    produce: async function () {
      this.producing = true
      await fetch(`/api/proposals/${this.viewItem.id}/produce`, {
        method: 'POST',
      })
      // move to history tab
      if (this.$refs.propHistory) {
        ;(this.$refs.propHistory as any).refresh()
      }
      this.producing = false
      this.currentTab = 1
    },
    removeProposal: async function (id: number | null) {
      if (id === null) {
        // console.log('Someone tried to remove nothing')
        return
      }

      this.showRemoveModal = false
      this.loading = true

      await fetch(`/api/proposals/${id}`, { method: 'DELETE' })

      this.proposals = this.proposals.filter((proposal) => proposal.id !== id)
      this.loading = false
    },
    openDocument: async function (document: IProposalDocument) {
      // TODO: Show a toast or some other message when errors happen
      try {
        const canOpenResource = await fetch(`${document.resourceLink}`)

        if (canOpenResource.ok) {
          // console.log('opening ' + document.resourceLink)
          window.open(document.resourceLink)
        } else {
          // console.log('Was unable to open resource' + document.resourceLink)
        }
      } catch {
        // console.log('Was unable to open resource' + document.resourceLink)
      }
    },
  },
})
